<div>
    <div class="custom-file" *ngIf="inlineUploadStyle">
        <div class="row">

            <div class="col-md-9">
                <input *ngIf="visible" [attr.multiple]="multiselect" style="cursor: pointer;"
                    (click)="onFileSelectOpen()" [disabled]="disabled" type="file" title=" " (blur)="onBlur()"
                    style="cursor: pointer;" class="custom-file-input" id="customFile" (change)="onChange($event)"
                    [name]="name" [ngModel]="fileDetail.fileRef"
                    (ngModelChange)="fileDetail.fileRef ? fileDetail.fileRef : null"
                    accept=".pdf,.jpeg,.jpg,.png,.xlsx,.xls,.mp4" #fileInput>
                <label class="custom-file-label placeholder-color" for="customFile">{{placeholder}}
                    <span *ngIf="checkRequired(formValue)" class="mandatoryColor">*</span>
                </label>

                <label *ngIf="documentTemplateUrl" (click)="download(documentTemplateUrl)"
                    class="green-color-text link-text">Download Template
                </label>
                <label class="display-block" style="color :grey">File size upto {{fileSizeRestrict}} MB</label>
                <label *ngIf="fileDetail.types" class="green-color-text">({{fileDetail.types}})</label>
            </div>
            <div class="col-md-3">
                <button *ngIf="!withoutButton"
                    [ngStyle]="{'cursor': disabled || !(status === STATUS.SELECTED) ? 'not-allowed' : 'pointer'}"
                    type="button" [disabled]="disabled || !(status === STATUS.SELECTED)" (click)="upload()"
                    class="btn btn-secondary">
                    Upload
                </button>
                <span class="fa fa-check" style="color: green;" *ngIf="status === STATUS.UPLOADED"></span>
            </div>
        </div>
        <br>
    </div>
    <div class="custom-file" style="margin-left: -29px;" style="padding:0" *ngIf="!inlineUploadStyle">
        <div class="row margin-reset">
            <div [class]="dropDownDivClass">
                <select required=true [disabled]="isCategoryDisabled()" class="form-control m-input" id="dropDown"
                    [(ngModel)]="selectedCategory" (change)="onCategoryChange(value)">
                    <option value="" disabled>Select</option>
                    <option [ngValue]="category" *ngFor="let category of categories" [disabled]="!category.enable">
                        {{category}}</option>
                </select>
            </div>
            <div [class]="fileInputDivClass">
                <input *ngIf="visible" [attr.multiple]="multiselect" style="cursor: pointer;"
                    (click)="onFileSelectOpen()" [disabled]="disAllow || disabled" type="file" title=" "
                    (blur)="onBlur()" style="cursor: pointer;" class="custom-file-input" id="customFile"
                    (change)="onChange($event)" [name]="name" [ngModel]="fileDetail.fileRef"
                    (ngModelChange)="fileDetail.fileRef ? fileDetail.fileRef : null"
                    accept=".pdf,.jpeg,.jpg,.png,.xlsx,.xls,.mp4" #fileInput>
                <label class="custom-file-label placeholder-color" for="customFile">
                    <!-- <span *ngIf="checkRequired(formValue)">{{placeholder}}<span class="mandatoryColor">*</span></span> -->
                    <ng-container *ngIf="!isCategorised">
                        <label class="filenameCustom" *ngIf="isMultiSelect; else placeHolderBlock">
                            <ul>
                                <li *ngFor="let file of fileDetails">
                                    {{file.name}}
                                </li>
                            </ul>
                        </label>
                        <div *ngIf="isMultiSelect" class="red-color-text">
                            <ul>
                                <li class="red-color-text" *ngFor="let e of errors">{{e}}</li>
                            </ul>
                        </div>
                        <ng-template #placeHolderBlock>
                            <span>
                                {{placeholder}}
                            </span>
                        </ng-template>
                    </ng-container>
                    <ng-container *ngIf="isCategorised">
                        <label *ngIf="isMultiSelect; else placeHolderBlock">
                            <ul>
                                <li *ngFor="let file of fileDetails">
                                    {{file.name}}
                                </li>
                            </ul>
                            <ng-template #placeHolderBlock>
                                <span>
                                    {{placeholder}}
                                </span>
                            </ng-template>
                        </label>
                        <!-- <ul>
                                <li *ngFor="let category of categorisedFileDetails">
                                    <ul *ngIf="this.selectedCategory === category.name">{{category.name}}
                                        <li *ngFor="let file of category.fileDetails">
                                            {{file.name}}
                                        </li>
                                    </ul>
                                </li>
                            </ul> -->
                        <div *ngIf="isMultiSelect" class="red-color-text">
                            <ul>
                                <li class="red-color-text" *ngFor="let e of errors">{{e}}</li>
                            </ul>
                        </div>
                    </ng-container>
                </label>

                <label *ngIf="documentTemplateUrl" (click)="download(documentTemplateUrl.toString())"
                    class="green-color-text link-text">Download Template
                </label>
                <label class="green-color-text display-block">File size upto {{fileSizeRestrict}} mb</label>
                <label *ngIf="fileDetail.types" class="green-color-text">({{fileDetail.types}})</label>
                <ng-container *ngIf="!isCategorised">
                    <label *ngIf="!isMultiSelect" class="red-color-text">{{error}}</label>
                </ng-container>
            </div>
        </div>
        <div class="row margin-reset">
            <div class="col-md-12">
                <button *ngIf="!withoutButton"
                    [ngStyle]="{'cursor': isdisabled || disabled || !(status === STATUS.SELECTED) ? 'not-allowed' : 'pointer'}"
                    type="button" [disabled]="isdisabled || disabled || !(status === STATUS.SELECTED)"
                    (click)="upload()" class="btn btn-outline-success">
                    Upload
                </button>
                <span class="fa fa-check" style="color: green;" *ngIf="status === STATUS.UPLOADED"></span>

            </div>
        </div>
        <br>
    </div>
    <br />

    <table class="table table-striped" *ngIf="isCategorised">
        <tr>
            <!-- <th>{{tableLabel.sno}}</th> -->
            <th>{{tableLabel.categoryName}}</th>
            <th>{{tableLabel.file}}</th>
            <th>{{tableLabel.action}}</th>
        </tr>
        <tr *ngFor="let category of categorisedFileDetails;let i = index">
            <!-- <td>{{i + 1}}</td> -->
            <td>{{category.name}}</td>
            <td>
                <ul>
                    <li class="link-text" *ngFor="let fileName of category.fileNames; let i=index;"
                        (click)="download(category.downloadUrls[i])">{{fileName}}</li>
                </ul>
            <td>
                <a href="javascript:0" (click)="deleteCategoryUrls(category.name)">
                    <i class="la la-trash"></i>
                </a>
            </td>
        </tr>
    </table>

    <div *ngIf="isReviewRequiredSelect">
        <div class="main-heading-card row">
            <div>
                <h5 *ngIf="status === STATUS.UPLOADED && isReviewRequired" class="m-section__heading">Uploaded
                    Photographs:</h5>
            </div>
        </div>
        <div class="row col-md-12" style="padding:2em;text-align: center;">
            <div class="col-xl-4 col-md-4 col-sm-6" *ngFor="let file of previewPhotos;let i = index"
                style="color:#ef7e22">
                <img class="img_cus" [src]="file">
                <span>Uploaded Photographs {{i + 1}}</span>
            </div>
        </div>
    </div>

</div>